import { lazy } from "react";
// project imports
import MainLayout from "../layout/MainLayout";
import Loadable from "../ui-component/Loadable";

// dashboard routing
const DashboardDefault = Loadable(
  lazy(() => import("../views/dashboard/Default"))
);

// utilities routing
const UtilsEmployee = Loadable(lazy(() => import("views/utilities/Employee")));
const UtilsUser = Loadable(lazy(() => import("views/utilities/Users")));
const UtilsReport = Loadable(lazy(() => import("views/utilities/Report")));
const UtilsPhotoRequest = Loadable(
  lazy(() => import("views/utilities/PhotoRequest"))
);
const UtilsPenalty = Loadable(lazy(() => import("views/utilities/Penalty")));

// Notification
const Notification = Loadable(lazy(() => import("views/Notification/index")));
const NotificationCRUD = Loadable(
  lazy(() => import("views/Notification/create"))
);

// Notification
const SensitiveWord = Loadable(
  lazy(() => import("views/sensitive-word/index"))
);
const SensitiveWordCRUD = Loadable(
  lazy(() => import("views/sensitive-word/create"))
);

// Inquiry
const Inquiry = Loadable(lazy(() => import("views/inquiry/index")));

//Conversation
const Conversation = Loadable(lazy(() => import("views/conversation/index")));
const ConversationDetail = Loadable(
  lazy(() => import("views/conversation/detail"))
);
const ConversationChat = Loadable(
  lazy(() => import("views/conversation/chat"))
);

//Conversation
const SystemSetting = Loadable(
  lazy(() => import("views/system-setting/index"))
);

//Policy
const Payment = Loadable(lazy(() => import("views/payment/index")));
const AuthLogin3 = Loadable(
  lazy(() => import("views/pages/authentication/authentication3/Login3"))
);

// ==============================|| MAIN ROUTING ||============================== //
const admin = JSON.parse(localStorage.getItem("userInfo"));

const MainRoutes = {
  path: "/",
  element: (admin && <MainLayout />) || <AuthLogin3 />,
  children: [
    {
      path: "/",
      element: <DashboardDefault />,
    },
    {
      path: "/employee",
      element: <UtilsEmployee />,
    },
    {
      path: "/users",
      element: <UtilsUser />,
    },
    {
      path: "/inquiry",
      element: <Inquiry />,
    },
    {
      path: "/photo_request",
      element: <UtilsPhotoRequest />,
    },
    {
      path: "/penalty",
      element: <UtilsPenalty />,
    },
    {
      path: "/conversation",
      element: <Conversation />,
    },
    {
      path: "/conversation/detail/:conversation_id",
      element: <ConversationDetail />,
    },
    {
      path: "/conversation/chat/:conversation_id",
      element: <ConversationChat />,
    },
    {
      path: "/notification",
      element: <Notification />,
    },
    {
      path: "/notification/create",
      element: <NotificationCRUD />,
    },
    {
      path: "/sensitive_word",
      element: <SensitiveWord />,
    },
    {
      path: "/sensitive_word/create",
      element: <SensitiveWordCRUD />,
    },
    {
      path: "/report",
      element: <UtilsReport />,
    },

    {
      path: "/system-setting",
      element: <SystemSetting />,
    },
    {
      path: "/payment",
      element: <Payment />,
    },
  ],
};

export default MainRoutes;
